const doc = [({"ko":({"adminCancelPolicyOption":({"fixedFee":"아래의 취소 수수료를 적용하는", "free":"취소 수수료를 무료로", "original":"취소 정책을 적용 할"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;